export default __webpack_public_path__ + "static/media/watch_later.34de93de.svg";